import Cookies from 'js-cookie';

const storage = window.favorites;
const getEntityIcons = (entity, id) =>
  document.querySelectorAll(`[data-favorites="${entity}-${id}"]`);
const getIcons = () => document.querySelectorAll('[data-favorites]');

const USER_API_HOST = window.userApiEndpoint;
const CABINET_API_HOST = window.cabinetApiEndpoint;
const ANALYTICS_ATTRIBUTE = 'data-card-analytics-options';

export const addFavorite = (entity, id, projectInfo) => {
  id = parseInt(id, 10);
  [].forEach.call(getEntityIcons(entity, id), (ico) => {
    ico.classList.add('-active');
  });
  storage[entity].push(id);

  if (window.isGuest) {
    Cookies.set('favorite_items', storage, { expires: 365, domain: window.cookieDomain });
  }

  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${USER_API_HOST}/favorites/${entity}/${id}`, true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.setRequestHeader('X-CSRF-Token', window.csrf);
  xhr.withCredentials = true;
  xhr.send();

  ga('ec:addProduct', { id, category: 'new_building' });
  ga('ec:setAction', 'add');

  if (!projectInfo) return;
  const { item_list_id, item_list_name, ...rest } = projectInfo;

  gtag('event', 'add_to_wishlist', {
    route_to_new_ga4: true,
    currency: 'usd',
    item_list_id,
    item_list_name,
    items: [rest],
  });
};

const removeFavorite = (entity, id) => {
  id = parseInt(id, 10);
  [].forEach.call(getEntityIcons(entity, id), (ico) => {
    ico.classList.remove('-active');
  });
  storage[entity].splice(storage[entity].indexOf(id), 1);

  if (window.isGuest) {
    Cookies.set('favorite_items', storage, { expires: 365, domain: window.cookieDomain });
  }

  const xhr = new XMLHttpRequest();
  xhr.open('DELETE', `${USER_API_HOST}/favorites/${entity}/${id}`, true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.setRequestHeader('X-CSRF-Token', window.csrf);
  xhr.withCredentials = true;
  xhr.send();

  ga('ec:addProduct', { id, category: 'new_building' });
  ga('ec:setAction', 'remove');
};

const toggleFavorite = (entity, id, projectInfo) => {
  id = parseInt(id, 10);
  if (storage[entity].indexOf(id) !== -1) {
    return removeFavorite(entity, id);
  }
  return addFavorite(entity, id, projectInfo);
};

const attachClick = () => {
  document.addEventListener('click', (event) => {
    const icons = getIcons();
    for (let i = 0; i < icons.length; i += 1) {
      if (icons[i].contains(event.target)) {
        event.preventDefault();
        const closestAnalyticsNode = icons[i].closest(`[${ANALYTICS_ATTRIBUTE}]`);
        const projectInfo = closestAnalyticsNode
          ? JSON.parse(closestAnalyticsNode.getAttribute(ANALYTICS_ATTRIBUTE))
          : null;
        const [entity, id] = icons[i].getAttribute('data-favorites').split('-');
        toggleFavorite(entity, id, projectInfo);
        break;
      }
    }
  });
};

export const syncFavorite = () => {
  [].forEach.call(getIcons(), (ico) => ico.classList.remove('-active'));
  Object.keys(storage).forEach((entity) => {
    storage[entity].forEach((id) => {
      [].forEach.call(getEntityIcons(entity, id), (ico) => {
        ico.classList.add('-active');
      });
    });
  });
};

const initUpdates = () => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', `${CABINET_API_HOST}/user/updates`, true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.withCredentials = true;
  xhr.addEventListener('load', () => {
    const response = JSON.parse(xhr.responseText);
    if (response.status !== 'ok' || response.data === 0) return;
    const updateNodes = document.querySelectorAll('[data-favorites-update]');
    [].forEach.call(updateNodes, (node) => {
      node.classList.add('-active');
    });
  });
  xhr.send();
};
export const initFavorite = () => {
  syncFavorite();
  attachClick();
  initUpdates();
};
